import React from 'react';
import Banner from '../elements/Banner'
import ProfilePicture from '../elements/ProfilePicture'
import BusinessName from '../elements/BusinessName'
import Social from '../components/Social'
import About from '../elements/About'
import SaveAsContact from '../components/SaveAsContact';
import Accordions from '../components/Accordions'
import ImageSwiper from '../elements/ImageSwiper'
import ClientsSwiper from '../elements/ClientsSwiper'
import CallToAction from '../elements/CallToAction'
import Share from '../elements/Share'
import Title from '../elements/Title'
import Line from '../elements/Line'
import LogoDesign from '../images/logoDesign.jpg'
// Import your image with the correct file path
import ImageSwiperCloser from '../elements/ImageSwiperCloser';

import { bgImageSrc, bannerImageSrc, logoImageSrc, images } from '../media';

import PriceList from '../images/priceList.jpeg'
import Accordion1 from '../elements/Accordion1';
import Accordion2 from '../elements/Accordion2';

const HomePage = () => {



    const divStyle = {
        backgroundImage: `url(${bgImageSrc})`, // Note the closing parenthesis
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    return (
        <div className='bg-gray-100'>
            <div className='bg-white w-full md:w-5/6 lg:w-3/4 mx-auto shadow-2xl border-card_borderColor rounded-2xl ' >

                <div style={divStyle}>
                    <Banner
                        type="rectangle"
                        image={bannerImageSrc}
                    />

                    <ProfilePicture
                        type="circleBorder"
                        image={logoImageSrc}

                    />

                    <BusinessName
                        businessName="Christina Lando"
                        businessDescription="אקדמיה לאיפור קבוע"
                    />

                    <div className='my-4 p-1 bg-transparent'></div>
                    <Social
                        phoneNumber="+972504433054"
                        phoneText="חייגו אליי"
                        whatsappNumber="+972504433054"
                        facebookUrl="https://www.facebook.com/profile.php?id=100063997990836&mibextid=ZbWKwL"
                        locationUrl=""
                        wazeUrl=""
                        wazeText="נווטו לקליניקה"
                        instagramUsername="christina.lando"
                        tiktokUsername=""
                        shareUrl="https://christinalando.netlify.app/"
                        type="circleBorder"

                    />


                    <SaveAsContact
                        text="שמרו אותי באנשי הקשר"
                        phoneNumber="+972504433054"
                        email="kristinlando@gmail.com"
                        firstName="Christina Lando - אקדמיה לאיפור קבוע"
                        lastName=""
                        type="rounded" />



                    <About
                        header="קצת עליי"
                        text="בשבע השנים האחרונות צברתי ניסיון נרחב בתחום האיפור הקבוע. במהלך תקופה זו, הקדשתי את עצמי ללימוד ולהנחיית תלמידותיי, במטרה להעניק להן את הכלים והידע הדרושים להפוך למומחיות בתחום. בעלת קורסים והשתלמויות מהמובילות בתחום בעולם (רוסיה אוקראינה ועוד ...)."
                        callToActionText="
האקדמיה שלנו כוללת מגוון רחב של קורסים, המותאמים לכל הרמות - החל ממתחילות ועד למקצועיות מנוסות."
                    />
                    {/* <div className='max-w-[500px] p-8 mx-auto'>
                        <img className=' mx-auto my-12  border-8 border-white ' src={PriceList} alt="" />
                    </div> */}


                    <Accordion1 type="rounded" />
                    <Accordion2 type="rounded" />


                </div>

                <div style={divStyle}>
                    <ImageSwiperCloser
                        type="top"
                        images={images} />
                    <ImageSwiper
                        images={images}
                        type="rounded"
                    />
                    <ImageSwiperCloser
                        type="bottom"
                        images={images} />
                </div>


                <div style={divStyle}>
                    <Title
                        text="לקוחות ממליצים" />

                    <ClientsSwiper
                        testimonials={[
                            {
                                "text": "כולם כל כך התלהבו מהעבודה שלך, ידיד פה עכשיו אומר שאת אומנית עם יד של אלופה וזה נראה אש והכי דומה לטבעי",
                                "author": ""
                            },
                            {
                                "text": "בוקר טוב אהובה. רק רציתי להגיד לך שכבר מאוד אוהבת את התוצאה והצבע ממש בול מה שרציתי ואני מאוד שמחה על כך.. ואין ספק שאת אדם הכי מקצועי שאני פגשתי בתחום הזה ( ופגשתי לפחות 3 ). רק רציתי להגיד עוד פעם תודה ענקית, אין מאושרת ממני. ❤️ וכמובן אני אמליץ עלייך בחום לכל מי שיהיה מעוניין",
                                "author": ""
                            },
                            {
                                "text": " ❤️❤️מאמוששש חייבת להגיד לך שאת מדהימה ברמות!!!!! באמת באמת באמת שאין דברים כמוך את מקצועית בטירוף. יצא מהמםםםםם אני פשוט פשוט עפה על זה יצא ממש מסורטט ומיוחד את תותחית על!!!! תודה ענקית",
                                "author": ""
                            },
                            {
                                "text": "היי בוקר אור ❤️ זוכרת אותי יום ראשון הייתי אצלך לגבות קבלתי מחמאות ונתתי את הפלאפון שלך לתיאום",
                                "author": ""
                            },
                            {
                                "text": "שבוע טוב יקירתי, אני מרגישה נפלא והגבות מהממות. מקבלת המון מחמאות, זה נראה מושלם צדקת לגבי הצבע שחברת. זה כל כך טבעי ויפה בדיוק כמו שרציתי. את מאוד מקצועית מוכשרת ומקסימה. תודה רבה ❤️",
                                "author": ""
                            },

                        ]
                        }
                    />
                    {/* <Line /> */}

                    {/* <div data-aos="fade-zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="800">
                        <h1 dir='rtl' className='text-center px-6 max-w-[600px] mx-auto'>
                            שלום לכם לקוחות יקרים! התחלתי לעבוד עם שירות לקביעת תורים, מעכשיו תוכלו להזמין אצלי תורים בפשטות ובקלות. הורידו את האפליקציה בכפתור למטה, הירשמו וחפשו לפי קוד העסק:
                            <br />
                            <span className='font-bold'> 25670</span>
                        </h1>

                    </div> */}
                    {/* <div className='shake-animation  max-w-[300px] mx-auto'>


                        <a
                            href="https://point-app.net/download/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group hover:shadow-lg hover:shadow-[#f5cec8]/60 transition ease-in-out hover:scale-105 p-1 rounded-xl bg-gradient-to-br from-[#000] via-[#333] to-[#000] hover:from-[#333] hover:via-[#000] hover:to-[#333] max-w-[300px] mx-auto flex flex-col justify-around items-center text-center border-2 border-[#f5cec8] dir-rtl"
                        >
                            <div className="px-6 py-2 backdrop-blur-xl bg-gradient-to-tr from-black to-[#333] rounded-xl font-bold h-full">
                                <span className="block text-lg mb-1 font-semibold text-[#fff] group-hover:text-[#f5cec8]">
                                    לקביעת תור דרך האפליקציה לחצי כאן
                                </span>
                                <span className="block text-lg mb-1 font-semibold text-[#f5cec8]">
                                    קוד עסק 25670
                                </span>
                                <svg
                                    className="w-6 h-6 stroke-[#f5cec8] group-hover:stroke-[#fff]"
                                    strokeWidth="1.8"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                        strokeLinejoin="round"
                                        strokeLinecap="round"
                                    ></path>
                                </svg>
                            </div>
                        </a>

                    </div> */}

                    <div data-aos="fade-down"
                        data-aos-easing="ease-in-out">
                        <Line />

                        <CallToAction
                            header="לייעוץ ופרטים נוספים לחצי על הלוגו"
                            phoneNumber="+972504433054"
                            contact="whatsapp"
                            type="circleBorder"
                            image={LogoDesign} />

                        <Line />
                    </div>
                    <Accordions
                        header="השירותים שלי"
                        listItems={[
                            'מניקור יסודי',
                            'לק ג׳ל עם מבנה אנטומי',
                            'לק ג׳ל ללא מבנה אנטומי',
                            'בנייה באקריל',
                            'מילוי אקריל',
                            'בנייה בג׳ל',
                            'מילוי ג׳ל',
                            'לק ג׳ל רגליים',
                            'תיקון ציפורן',
                            'הסרת לק',
                            'קישוטים',
                        ]}

                        headerContact="תקשורת ושעות פעילות"
                        phoneNumber="+972504433054"
                        email="kristinlando@gmail.com"
                        activityHours={[
                            { text: "א' - ו'", hours: "" },

                        ]}
                        type="rounded" />

                    <Share
                        url="https://christinalando.netlify.app/"
                        type="circleBorder"
                    />
                </div>

            </div>
        </div>

    )
}

export default HomePage